import { getApiClient } from './ApiClient'

export const mealIngredientCategoryListPromise = (params) => {
  return getApiClient()
    .get('/meal-ingredient/categories', {
      params
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const mealIngredientCategoryDetailPromise = (id) => {
  return getApiClient()
    .get(`/meal-ingredient/categories/${id}`)
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}

export const mealIngredientCategoryUpsertPromise = (body) => {
  return getApiClient()
    .post('/meal-ingredient/categories/upsert', {
      body
    })
    .then(resp => {
      return Promise.resolve(resp.data)
    })
}
